<template>
    <div v-if="banners.length >= 1 && displayBanner" :class="[containerClass, position === 'bottom' ? 'sticky-bottom' : '']">
        <div v-bind:class="{'container-fluid': !banner.full_width}" v-for="(banner, index) in banners" :key="index">
            <div v-html="banner.description"> </div>
        </div>
    </div>
</template>
<script setup>
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import axios from "axios";

const props = defineProps({
    position: {
        type: String,
        required: true,
    },
});

const route = useRoute();

// Data
const banners = ref([]);
const containerClass = ref('banner');
const displayBanner = ref(false);

// Methods
const getBanners = () => {
    axios
        .post(process.env.VUE_APP_API_BASE + "auth/getBanners",
        {
            position: props.position,
        },
        {
            headers: {
                "Content-type": "application/json",
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        })
        .then((response) => {
            if (response.data.error === false) {
                banners.value = response.data.banners
            }
        });
};

// Lifecycle
onMounted(() => {
    setTimeout(() => {
        if (route.name != 'Carts' && route.name != 'Checkout') {
            getBanners();
            displayBanner.value = true;
            containerClass.value = props.position + '-' + containerClass.value;
        }
    }, 1000)
});
</script>
